"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.amenityFullName = exports.amenityName = void 0;
const capitalize_1 = require("../../../util/capitalize");
// Some amenities start with a prefix to avoid duplicates (e.g. view_sea, location_sea)
const amenityName = (name) => {
    return (0, capitalize_1.capitalize)(name.includes('_') ? name.split('_')[1] : name);
};
exports.amenityName = amenityName;
const amenityFullName = (name) => {
    return name.includes('_') ? `${(0, capitalize_1.capitalize)(name.split('_')[1])} ${name.split('_')[0]}` : (0, capitalize_1.capitalize)(name);
};
exports.amenityFullName = amenityFullName;
//# sourceMappingURL=helpers.js.map